import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const style = createStyleSheet({
  drawer: {
    zIndex: 3,
  },
  container: {
    paddingLeft: 32,
    paddingRight: 32,
    paddingBottom: 128,
  },
  abstract: {
    marginTop: 12,
    ...TYPOGRAPHY.BODY3,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  current: {
    marginTop: 48,
    marginBottom: 24,
    ...TYPOGRAPHY.H2,
    fontWeight: 700,
  },
  wrapperAddLanguages: {
    display: 'flex',
    marginTop: 32,
  },
  containerDropdownLanguages: {
    marginLeft: 5,
  },
  errorMessageList: {
    listStylePosition: 'inside',
  },
});

export default style;
